import React from "react"
import SlateNode from "../slate-node"

const CaptionedImage = ({ attributes, data, children, node }) => {
  const { alignment = "center", margin = 12, width = 800, wrapText } = data

  const figureStyle = {
    display: "block",
    margin: `${margin}px 0`,
    maxWidth: `100%`,
    width: `${parseInt(width)}px`
  }

  const containerStyle = { width: "100%", textAlign: alignment }

  if (wrapText) {
    figureStyle.margin =
      alignment === "left"
        ? `0 ${margin}px ${margin}px 0`
        : `0 0 ${margin}px ${margin}px`

    containerStyle.float = alignment
    if (width) containerStyle.width = parseInt(width) + parseInt(margin)
  } else {
    if (alignment === "left") {
      figureStyle.margin = `${margin}px auto ${margin}px 0`
    } else if (alignment === "right") {
      figureStyle.margin = `${margin}px 0 ${margin}px auto`
    } else {
      figureStyle.margin = `${margin}px auto ${margin}px auto`
    }
  }

  return (
    <SlateNode node={node} {...attributes} style={containerStyle}>
      <figure style={figureStyle}>{children}</figure>
    </SlateNode>
  )
}

export default CaptionedImage
